import * as yup from 'yup';

const OrderSchema = yup.object({
  name: yup.string().trim().required('Vui lòng nhập tên đơn vị đặt hàng'),
  phoneNumber: yup
    .string()
    .trim()
    .required('Vui lòng nhập số điện thoại')
    .matches(/^[0][0-9]{9,10}$/, 'Số điện thoại không hợp lệ'),
  shippingAddress: yup.object({
    address: yup.string().trim().required('Vui lòng nhập địa chỉ cụ thể'),
    city: yup.string().trim().required('Vui lòng chọn thành phố'),
    ward: yup.string().trim().required('Vui lòng chọn phường/xã'),
  }),
  items: yup
    .array()
    .of(
      yup.object({
        productId: yup.string().trim().required('ID sản phẩm không được để trống'),
        quantity: yup.number().positive().required('Số lượng không được để trống'),
        price: yup.number().positive().required('Giá không được để trống'),
        name: yup.string().required('Tên không được để trống'),
      })
    )
    .min(1, 'Vui lòng thêm ít nhất một sản phẩm vào đơn hàng')
    .required('Vui lòng thêm sản phẩm vào đơn hàng'),
  paymentMethod: yup.string().trim().required('Vui lòng chọn phương thức thanh toán'),
  note: yup.string().trim().optional(),
});

export { OrderSchema };
